import { RecurrencePattern } from "../../types";
import { z } from "zod";

export type EventType =
  | "custom"
  | "recommended"
  | "block"
  | "deleted"
  | "default"
  | "auto_resize"
  | "backoff";

export type ScheduleStatus = "pending" | "approved" | "rejected";

export interface ScheduleCard {
  id: string;
  title: string;
  start: string;
  end: string;
  type: EventType;
  clusterMin?: number;
  clusterMax?: number;
  sizeFrom?: string;
  sizeTo?: string;
  savings?: string;
  reasoning?: string[] | { timestamp: string; reason: string }[];
  status: ScheduleStatus;
  recurrencePattern?: RecurrencePattern;
  created_by?: number;
  change: "upsize" | "downsize" | "no_change" | "daybreak";
}

// Define Zod schemas for request and response
export const ApplyRecommendedEventsRequestSchema = z.object({
  warehouse_name: z.string(),
  instance_id: z.string(),
  start_time: z.string(), // Assuming ISO string format
  end_time: z.string(), // Assuming ISO string format
});

export const ApproveScheduleResponseSchema = z.object({
  schedule_id: z.number(),
  warehouse_name: z.string(),
  configuration: z.any(), // Assuming WarehouseConfig is any
  start_time: z.string(), // Assuming ISO string format
  end_time: z.string(), // Assuming ISO string format
  schedule_type: z.string(), // Assuming ScheduleType is a string
  status: z.string(), // Assuming ScheduleStatus is a string
  reason: z.string(),
  created_by: z.number(),
  created_at: z.string(), // Assuming ISO string format
  updated_by: z.number().nullable(),
  updated_at: z.string().nullable(), // Assuming ISO string format
  recurrence_pattern: z.any().nullable(),
});
